<div class="checkout-page">

  <!-- =====================================================
         HERO
    ====================================================== -->

  <section class="checkout-hero">

    <div class="checkout-hero__content">

      <span class="checkout-hero__eyebrow">
        FINALIZAR COMPRA
      </span>

      <h1>
        Resumen de tu
        <span class="nina-brand-italic">pedido</span>
      </h1>

      <p>
        Revisa los detalles de tu compra antes de realizar el pago.
      </p>

    </div>

  </section>


  <!-- =====================================================
         CONTENIDO
    ====================================================== -->

  <main class="checkout-container">

    <!-- =================================================
             TEMPORIZADOR
        ================================================== -->

    <div class="checkout-timer">

      <div class="checkout-timer__icon">
        <mat-icon>schedule</mat-icon>
      </div>

      <div class="checkout-timer__text">

        <span>
          RESERVA DE PEDIDO
        </span>

        <strong>
          Tienes {{ getFormattedTime() }} para completar tu compra
        </strong>

      </div>

    </div>


    <!-- =================================================
             LAYOUT PRINCIPAL
        ================================================== -->

    <div class="checkout-layout">


      <!-- =============================================
                 COLUMNA IZQUIERDA
            ============================================== -->

      <section class="checkout-products">

        <div class="checkout-section-heading">

          <div>
            <span>RESUMEN</span>

            <h2>
              Tus productos
            </h2>
          </div>

          <div class="checkout-products-count">
            {{ productsCart.length }}
            {{ productsCart.length === 1 ? 'producto' : 'productos' }}
          </div>

        </div>


        <!-- PRODUCTOS -->

        <div class="checkout-product-list" *ngIf="productsCart.length > 0">

          <article class="checkout-product" *ngFor="let product of productsCart">

            <div class="checkout-product__content">

              <div class="checkout-product__info">
                <span class="checkout-product__eyebrow">PRODUCTO</span>

                <h3>
                  {{
                  product?.productoAgrupador ||
                  product?.producto ||
                  product?.nombre ||
                  product?.descripcionProducto ||
                  'Producto'
                  }}
                </h3>

                <p *ngIf="product?.descripcionProducto || product?.producto">
                  {{
                  product?.descripcionProducto ||
                  (
                  product?.producto !== product?.productoAgrupador
                  ? product?.producto
                  : ''
                  )
                  }}
                </p>
              </div>


              <div class="checkout-product__details">

                <div class="checkout-product__quantity">

                  <span>
                    Cantidad
                  </span>

                  <strong>
                    {{ product.qty }}
                  </strong>

                </div>


                <div class="checkout-product__price">

                  <span>
                    Total
                  </span>

                  <strong>
                    {{
                    (
                    product.qty *
                    (
                    product.precioPromocionPorProducto ??
                    product.precioPromocion ??
                    product.precioNormal ??
                    product.precioVenta
                    )
                    )
                    | currency:'USD':'symbol':'1.2-2'
                    }}
                  </strong>

                </div>

              </div>

            </div>

          </article>

        </div>


        <!-- =========================================
                     INFORMACIÓN DE ENTREGA
                ========================================== -->

        <div class="checkout-delivery-card">

          <div class="checkout-delivery-card__header">

            <div class="checkout-delivery-card__icon">
              <mat-icon>
                {{
                requestBodyNina.EntregaADomicilio
                ? 'local_shipping'
                : 'store'
                }}
              </mat-icon>
            </div>

            <div>

              <span>
                ENTREGA
              </span>

              <h3>
                {{
                requestBodyNina.EntregaADomicilio
                ? 'Entrega a domicilio'
                : 'Recoger en sucursal'
                }}
              </h3>

            </div>

          </div>


          <div class="checkout-delivery-card__body">

            <mat-icon>
              location_on
            </mat-icon>

            <div>

              <span>
                {{
                requestBodyNina.EntregaADomicilio
                ? 'Dirección de entrega'
                : 'Sucursal'
                }}
              </span>

              <strong>
                {{
                requestBodyNina.EntregaADomicilio
                ? requestBodyNina.Direccion
                : cookieBranch.nombre
                }}
              </strong>

            </div>

          </div>


          <div class="checkout-shipping-cost" *ngIf="requestBodyNina.EntregaADomicilio">

            <span>
              Costo de envío
            </span>

            <strong>
              {{ costoEnvio | currency:'USD':'symbol':'1.0-0' }}
            </strong>

          </div>

        </div>

      </section>



      <!-- =============================================
                 COLUMNA DERECHA
            ============================================== -->

      <aside class="checkout-payment">

        <div class="checkout-payment-card">

          <!-- CABECERA -->

          <div class="checkout-payment-card__header">

            <span>
              PAGO
            </span>

            <h2>
              Realiza tu pago
            </h2>

            <p>
              Tu información de pago se procesa de forma segura.
            </p>

          </div>


          <!-- STRIPE -->

          <div class="checkout-stripe" *ngIf="paymentIntentCreated && !freePurchase">

            <div class="checkout-stripe__header">

              <mat-icon>
                lock
              </mat-icon>

              <span>
                Pago seguro
              </span>

            </div>

            <div class="checkout-stripe__element">

              <ngx-stripe-elements *ngIf="elementsOptions.clientSecret" [stripe]="stripe"
                [elementsOptions]="elementsOptions">

                <ngx-stripe-payment [options]="paymentElementOptions" (ready)="onStripeReady()"
                  (loaderror)="onStripeLoadError($event)">
                </ngx-stripe-payment>

              </ngx-stripe-elements>

            </div>

          </div>


          <!-- COMPRA GRATUITA -->

          <div class="checkout-free" *ngIf="freePurchase">

            <div class="checkout-free__icon">
              <mat-icon>
                celebration
              </mat-icon>
            </div>

            <span>
              COMPRA SIN COSTO
            </span>

            <h3>
              Tu compra es completamente gratuita
            </h3>

            <p>
              No necesitas realizar ningún pago.
              Solo confirma tu pedido para finalizar.
            </p>

          </div>


          <!-- =====================================
                         PUNTOS
                    ====================================== -->

          <div class="checkout-points">

            <div class="checkout-points__header">

              <div>

                <span>
                  PUNTOS NINA
                </span>

                <strong>
                  {{ userPointsData ? userPointsData.puntos : 0 }}
                </strong>

              </div>

              <mat-icon>
                stars
              </mat-icon>

            </div>


            <div class="checkout-points__used" *ngIf="usePoints">

              <span>
                Descuento aplicado
              </span>

              <strong>
                {{
                pointsToUse
                | currency:'USD':'symbol':'1.0-0'
                }}
              </strong>

            </div>

          </div>


          <!-- =====================================
                         TOTAL
                    ====================================== -->

          <div class="checkout-total">

            <div class="checkout-total__row">

              <span>
                Subtotal
              </span>

              <strong>
                {{ total | currency:'USD':'symbol':'1.0-0' }}
              </strong>

            </div>


            <div class="checkout-total__row" *ngIf="requestBodyNina.EntregaADomicilio">

              <span>
                Envío
              </span>

              <strong>
                {{ costoEnvio | currency:'USD':'symbol':'1.0-0' }}
              </strong>

            </div>


            <div class="checkout-total__row checkout-total__row--points" *ngIf="usePoints">

              <span>
                Puntos utilizados
              </span>

              <strong>
                - {{
                pointsToUse
                | currency:'USD':'symbol':'1.0-0'
                }}
              </strong>

            </div>


            <div class="checkout-total__divider"></div>


            <div class="checkout-total__final">

              <span>
                Total a pagar
              </span>

              <strong>
                {{
                (
                total +
                costoEnvio -
                pointsToUse
                )
                | currency:'USD':'symbol':'1.0-0'
                }}
              </strong>

            </div>

          </div>


          <!-- BOTÓN -->

          <button class="checkout-pay-button" mat-raised-button type="button" (click)="pay()"
            [disabled]="!isPaying || (!freePurchase && !stripeReady)">

            <span>
              {{
              freePurchase
              ? 'CONFIRMAR PEDIDO'
              : 'PAGAR PEDIDO'
              }}
            </span>

            <mat-icon>
              arrow_forward
            </mat-icon>

          </button>


          <p class="checkout-secure-text">

            <mat-icon>
              verified_user
            </mat-icon>

            Compra segura y protegida

          </p>

        </div>

      </aside>

    </div>

  </main>

</div>
